import { useEffect } from 'react'
import { useChainId } from 'wagmi'

import { withSuspense } from '@/ui/utils/withSuspense'

import { Token } from '@/domain/types/Token'
import { track } from '@/features/analytics'
import { SwapSkeleton } from './components/skeleton/SwapSkeleton'
import { SwapView } from './views/SwapView'

interface SwapContainerProps {
  isModal?: boolean
  token?: Token
  withHeading?: boolean
  simplified?: boolean
  isSwapPage?: boolean
  lockToToken?: boolean
  stackedSuccessScreen?: boolean
}

function SwapContainer({
  withHeading,
  simplified,
  isModal,
  isSwapPage,
  token,
  lockToToken,
  stackedSuccessScreen,
}: SwapContainerProps) {
  useEffect(() => {
    track('swap_form_viewed', { source: isModal ? 'modal' : 'swap_page' })
  }, [isModal])

  return (
    <SwapView
      withHeading={withHeading}
      simplified={simplified}
      isSwapPage={isSwapPage}
      isModal={isModal}
      token={token}
      lockToToken={lockToToken}
      stackedSuccessScreen={stackedSuccessScreen}
    />
  )
}

// @note: forces form to reset when network changes
function SwapContainerWithKey(props: SwapContainerProps) {
  const chainId = useChainId()
  return <SwapContainer key={chainId} {...props} />
}

const SwapContainerWithSuspense = withSuspense(SwapContainerWithKey, SwapSkeleton)

export { SwapContainerWithSuspense as SwapContainer }
